// extracted by mini-css-extract-plugin
module.exports = {"navItem":"nav-item_navItem__xZ3QR","navItemDark":"nav-item_navItemDark__M6AN5","submenu":"nav-item_submenu__A3NX5","subitem":"nav-item_subitem__Sto_j"};